import React from 'react'

import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import a10 from "../../../assets/a10.png";
import { Link } from 'react-router-dom';

const MT = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Macro & Treasury Research</span>
                    </div>
                    <h1>Macro & Treasury Research</h1>
                    <p>
                        At PSJ Capital Ventures, we believe successful investing begins with a deep understanding of the macroeconomic forces that shape market cycles, asset prices, investor sentiment, and capital flows. Our Macro & Treasury Research Desk provides clients with actionable insights rooted in data, global trends, and real-time developments — helping them stay ahead of the curve.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={a10} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    {/* <h2>Navigating Markets with a Macro Lens.</h2>
                    <p>
                       Whether you're a family office, corporate treasury, HNI investor, or portfolio manager, our macro research serves as the backbone for informed decision-making across asset classes - equities, debt, currency, commodities, and alternatives.
                    </p> */}


                    <h3 style={{ color: 'black' }}>What We Cover</h3>

                    <h5>Global Macro</h5>
                    <ul>
                        <li>	US Federal Reserve policy, interest rates, yield curve</li>
                        <li>	Inflation & commodity cycles (energy, crude, agri)</li>
                        <li>	Global bond markets, dollar dynamics</li>
                        <li>	Geopolitical risks and their economic spillovers</li>
                    </ul>

                    <h5>India Macro</h5>
                    <ul>
                        <li>		RBI policy, liquidity stance, monetary tools</li>
                        <li>		Fiscal deficit, budgetary announcements, revenue trends</li>
                        <li>		Inflation outlook (WPI/CPI), IIP, GDP growth</li>
                        <li>		INR dynamics, forex reserves, import-export trends</li>
                    </ul>
                    <h5>Market Outlooks</h5>
                    <ul>
                        <li>		Equity market valuation metrics</li>
                        <li>		Sectoral rotation and leadership cycles</li>
                        <li>		Debt market trends — G-Sec yields, corporate bonds, credit spreads</li>
                        <li>		Gold, crude oil, and commodity cycles</li>
                    </ul>
                    <h5>Treasury Insights</h5>
                    <ul>
                        <li>		Corporate treasury allocation strategies</li>
                        <li>		Liquidity planning and cash deployment models</li>
                        <li>		Yield curve positioning</li>
                        <li>		Credit risk monitoring and spread analysis</li>
                    </ul>


                    <h3 style={{ color: 'black' }}>Key Research Outputs</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 	Weekly Macro Snapshots </h5>
                            <p>Crisp analysis of key economic data, market moves, central bank commentary
                            </p>
                            <h5>2. 	Monthly Macro Outlook </h5>
                            <p>Forward-looking view on markets, interest rates, inflation, policy cues</p>
                        </div>
                        <div>
                            <h5>3. 	Thematic Research Notes </h5>
                            <p>Deep dives into structural trends (de-dollarization, AI impact, India infra boom, etc.)</p>
                            <h5>4. 	Event-Based Briefs </h5>
                            <p>Real-time takes on Budget, Fed meetings, RBI MPC, geopolitical escalations</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Why PSJ Capital Ventures?</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•	Independent Thinking  </li>
                                <li>✓ 	•	Multi-Asset Thinking  </li>
                                <li>✓ 	•	Customized Research  </li>
                                <li> ✓	•	Macro Calls With Accountability  </li>
                            </ul>
                        </div>
                    </div>






                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Macro Tools We Track</h3>

                        <ul>
                            <li>✓ 		US 10-year & Indian G-Sec yields</li>
                            <li>✓ 		India-US yield spreads</li>
                            <li>✓ 		DXY (Dollar Index)</li>
                            <li>✓ 		Brent & WTI crude prices</li>
                            <li>✓ 		Repo rate, Reverse Repo, MSF</li>
                            <li>✓ 		RBI OMO & VRRR data</li>
                            <li>✓ 		Credit spread indicators</li>
                            <li>✓ 		PMI data, IIP, WPI/CPI</li>
                            <li>✓ 		NSE bond order books</li>
                        </ul>
                        <p>
                            Let’s Talk Macro. Let’s Position You Ahead.

                            Whether you are managing long-term wealth, a corporate treasury desk, or looking to understand where markets are headed, our Macro & Treasury Research gives you the edge.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>Mutual Funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default MT